import React from "react";
import { Topbar } from "@components";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { localStorage, formatShareName } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { PUBLIC_ROUTE, PRIVATE_ROUTE, } from '@router/route.constants';
import { AuthLogo } from '@assets';

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
`;

const Title = styled.div`
  margin: 24px;
  color: #2A2A2A;
  text-align: left;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
`;

const Rules = styled.div`

  color: #2A2A2A;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */

  user-select: none; /* Disable text selection */
  -webkit-user-select: none; /* For Safari */
  -moz-user-select: none; /* For Firefox */
  -ms-user-select: none; /* For Internet Explorer/Edge */
  -webkit-touch-callout: none; /* Disable context menu on touch devices */
  -moz-touch-callout: none;
  -ms-touch-callout: none;
  -webkit-touch-callout: none;
`;

const ShareTerms = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  const ruleText =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? state?.termsAndConditions?.tc_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? state?.termsAndConditions?.tc_mm
        : state?.termsAndConditions?.tc_ch;

  const goBack = () => {
    navigate(`/${PRIVATE_ROUTE.SHARE_HISTORY}`, {
      state: { ...state },
    });
  };

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`} />
  }

  return (
    <>
      <Topbar title={t("common.termsAndConditions")} goBack={goBack} />
      <RootContainer>
        <AuthLogo style={{margin: "0 auto"}} />
        <TitleWrapper>
          <Title> {formatShareName(state?.share_type)}</Title>
        </TitleWrapper>
        <Rules dangerouslySetInnerHTML={{ __html: ruleText }} />
      </RootContainer>
    </>
  );
};

export default ShareTerms;
